// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_content-module__container--1dkjP"};